import {
  forwardRef,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  AddRounded,
  ArrowBackRounded,
  CloseRounded,
  ContentCopyRounded,
  DesktopMacOutlined,
  EditOutlined,
  PhoneIphone,
  SaveOutlined,
  SendOutlined,
  SyncOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import { blue, grey, yellow } from "@mui/material/colors";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AgGridTableWrapper from "../../components/agGrid/AgGridTableWrapper";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { isArray, isNil } from "lodash";
import FlxGrid from "../../_src_shared/components/layout/FlxGrid";
import PrimaryContentCard from "../../_src_shared/components/layout/PrimaryContentCard";
import { useColumnTypes } from "../../_src_shared/utils/agGrid/columnTypes/hooks/useColumnTypes";
import { formatPhone } from "../../_src_shared/utils/functions/formatPhone";
import BlockNoteEditor from "../../components/html/BlockNoteEditor";
import { exportToEmailHtml } from "../../components/html/exportToEmailHtml";
import TextInput from "../../components/inputs/TextInput";
import Flx from "../../components/layout/Flx";
import Screen from "../../components/layout/Screen";
import TitledHeaderWithSearch from "../../components/layout/TitledHeaderWithSearch";
import Txt from "../../components/typography/Txt";
import ChipItem from "../../components/ui/ChipItem";
import { useBorrowerSubmissionsHook } from "../../hooks/useBorrowerSubmissionsHook";
import { cachedDataItemSet } from "../../redux/actions/cachedDataActions";
import { colDefFilterMultiSelect } from "../../utils/agGrid/colDefs/colDefFilterMultiSelect";
import { sideBarColumnsFilters } from "../../utils/agGrid/sideBar/sideBarColumnsFilters";
import { CACHED_DATA_REDUCER_TYPES } from "../../redux/reducers/cachedDataReducer";
import { useNotificationFlowsHook } from "../../hooks/useNotificationFlowsHook";

const CACHED_DATA_KEY = CACHED_DATA_REDUCER_TYPES.EMAIL_TEMPLATES;

const getDummyEmailTemplates = (user) => {
  return [
    //     {
    //       _id: "template_1",
    //       templateTitle: "Borrower Portal Account Creation",
    //       templateDescription: "Template for borrower portal account activation",
    //       name: "custom",
    //       subject: "Action Required: Activate Your Loan Portal to Get Started",
    //       body: `<!DOCTYPE html>
    // <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    // <head>
    //   <meta charset="utf-8" />
    //   <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    //   <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    //   <!--[if mso]>
    //   <noscript>
    //     <xml>
    //       <o:OfficeDocumentSettings>
    //         <o:PixelsPerInch>96</o:PixelsPerInch>
    //       </o:OfficeDocumentSettings>
    //     </xml>
    //   </noscript>
    //   <![endif]-->
    //   <title>Underwriting Notes</title>
    //   <style type="text/css">
    //     body, table, td, p, a, li { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    //     table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    //     img { -ms-interpolation-mode: bicubic; border: 0; outline: none; text-decoration: none; }
    //   </style>
    // </head>
    // <body style="font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333; margin: 0; padding: 0; background-color: #f9f9f9;">
    //   <!--[if mso]>
    //   <table role="presentation" width="600" align="center" cellpadding="0" cellspacing="0" border="0"><tr><td>
    //   <![endif]-->
    //   <div style="max-width: 600px; margin: 0 auto; padding: 24px 20px; background-color: #ffffff;">
    //     <p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;">Hello,</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;">Your secure borrower portal is ready. This is the fastest way to manage your loan — submit your application, upload documents, and track your progress all in one place, 24/7.</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;"><u><a target="_blank" rel="noopener noreferrer nofollow" href="https://lq-borrower-portal-bgh5czcje5bqeafr.eastus2-01.azurewebsites.net/login" style="color: #1a73e8; text-decoration: underline;">[Create My Account →]</a></u></p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;">Setup takes less than two minutes. If you need any assistance, feel free to reach out directly.</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;"><br>Best regards,</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;">${user?.fullName}<br>${user?.phone ? `${formatPhone(user?.phone)} | ` : ""}${user?.emailAddress}</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;"></p>
    //   </div>
    //   <!--[if mso]>
    //   </td></tr></table>
    //   <![endif]-->
    // </body>
    // </html>`,
    //     },
    //     {
    //       _id: "template_2",
    //       name: "custom_2",
    //       templateTitle: "Another Custom Template",
    //       templateDescription: "An example template description",
    //       subject: "Subject Example",
    //       body: '<!DOCTYPE html>\n<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\n<head>\n  <meta charset="utf-8" />\n  <meta name="viewport" content="width=device-width, initial-scale=1.0" />\n  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n  <!--[if mso]>\n  <noscript>\n    <xml>\n      <o:OfficeDocumentSettings>\n        <o:PixelsPerInch>96</o:PixelsPerInch>\n      </o:OfficeDocumentSettings>\n    </xml>\n  </noscript>\n  <![endif]-->\n  <title>Underwriting Notes</title>\n  <style type="text/css">\n    body, table, td, p, a, li { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }\n    table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }\n    img { -ms-interpolation-mode: bicubic; border: 0; outline: none; text-decoration: none; }\n  </style>\n</head>\n<body style="font-family: \'SF Pro Display\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333; margin: 0; padding: 0; background-color: #f9f9f9;">\n  <!--[if mso]>\n  <table role="presentation" width="600" align="center" cellpadding="0" cellspacing="0" border="0"><tr><td>\n  <![endif]-->\n  <div style="max-width: 600px; margin: 0 auto; padding: 24px 20px; background-color: #ffffff;">\n    <p style="color: rgb(51, 51, 51);">Hello,</p><p style="color: rgb(51, 51, 51);">Your secure borrower portal is ready.</p><p style="color: rgb(51, 51, 51);"><u><a target="_blank" rel="noopener noreferrer nofollow" href="https://lq-borrower-portal-bgh5czcje5bqeafr.eastus2-01.azurewebsites.net/login" style="color: #1a73e8; text-decoration: underline;">[Create My Account →]</a></u></p><p style="color: rgb(51, 51, 51);">Setup takes less than two minutes. If you need any assistance, feel free to reach out directly.</p><p style="color: rgb(51, 51, 51);"><br>Best regards,</p>\n  </div>\n  <!--[if mso]>\n  </td></tr></table>\n  <![endif]-->\n</body>\n</html>',
    //     },
    //     {
    //       _id: "template_3",
    //       name: "custom_3",
    //       templateTitle: "Loan Application ",
    //       templateDescription:
    //         "Sending a customized link to a borrower tied to the salesperson",
    //       subject: "Loan Application Link",
    //       body: '<!DOCTYPE html>\n<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\n<head>\n  <meta charset="utf-8" />\n  <meta name="viewport" content="width=device-width, initial-scale=1.0" />\n  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n  <!--[if mso]>\n  <noscript>\n    <xml>\n      <o:OfficeDocumentSettings>\n        <o:PixelsPerInch>96</o:PixelsPerInch>\n      </o:OfficeDocumentSettings>\n    </xml>\n  </noscript>\n  <![endif]-->\n  <title>Underwriting Notes</title>\n  <style type="text/css">\n    /* Reset for email clients */\n    body, table, td, p, a, li { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }\n    table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }\n    img { -ms-interpolation-mode: bicubic; border: 0; outline: none; text-decoration: none; }\n  </style>\n</head>\n<body style="font-family: \'SF Pro Display\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333; margin: 0; padding: 0; background-color: #f9f9f9;">\n  <!--[if mso]>\n  <table role="presentation" width="600" align="center" cellpadding="0" cellspacing="0" border="0"><tr><td>\n  <![endif]-->\n  <div style="max-width: 600px; margin: 0 auto; padding: 24px 20px; background-color: #ffffff;">\n    <p style="color: rgb(51, 51, 51);">Hello,</p><p style="color: rgb(51, 51, 51);">Please visit visit the following link and fill out your loan application</p><p style="color: rgb(51, 51, 51);"><u><a target="_blank" rel="noopener noreferrer nofollow" href="https://resfin-partners-integration-b5e5b9ebc8fxdkd5.eastus2-01.azurewebsites.net/loan-application?link_id=69b06056c14f495fbe36ff23&amp;link_type=app" style="color: #1a73e8; text-decoration: underline;">Go To Loan Application -&gt;</a></u></p><p style="color: rgb(51, 51, 51);"><br>Best regards,</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;">Jimmy Oliva</p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;"></p>\n  </div>\n  <!--[if mso]>\n  </td></tr></table>\n  <![endif]-->\n</body>\n</html>',
    //     },
    {
      _id: "template_4",
      name: "custom_4",
      templateTitle: "Inline Variables",
      templateDescription: "Template for borrower portal account activation",
      subject: "Action Required: Activate Your Loan Portal to Get Started",
      body: '<!DOCTYPE html>\n<html lang="en" xmlns="http://www.w3.org/1999/xhtml">\n<head>\n  <meta charset="utf-8" />\n  <meta name="viewport" content="width=device-width, initial-scale=1.0" />\n  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n  <!--[if mso]>\n  <noscript>\n    <xml>\n      <o:OfficeDocumentSettings>\n        <o:PixelsPerInch>96</o:PixelsPerInch>\n      </o:OfficeDocumentSettings>\n    </xml>\n  </noscript>\n  <![endif]-->\n  <title>Underwriting Notes</title>\n  <style type="text/css">\n    /* Reset for email clients */\n    body, table, td, p, a, li { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }\n    table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }\n    img { -ms-interpolation-mode: bicubic; border: 0; outline: none; text-decoration: none; }\n  </style>\n</head>\n<body style="font-family: \'SF Pro Display\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333; margin: 0; padding: 0; background-color: #f9f9f9;">\n  <!--[if mso]>\n  <table role="presentation" width="600" align="center" cellpadding="0" cellspacing="0" border="0"><tr><td>\n  <![endif]-->\n  <div style="max-width: 600px; margin: 0 auto; padding: 24px 20px; background-color: #ffffff;">\n    <p style="color: rgb(51, 51, 51);">Hello,</p><p style="color: rgb(51, 51, 51);">Your secure borrower portal is ready. This is the fastest way to manage your loan — submit your application, upload documents, and track your progress all in one place, 24/7.</p><p style="color: rgb(51, 51, 51);"><u><a target="_blank" rel="noopener noreferrer nofollow" href="https://lq-borrower-portal-bgh5czcje5bqeafr.eastus2-01.azurewebsites.net/login" style="color: #1a73e8; text-decoration: underline;">[Create My Account →]</a></u></p><p style="color: rgb(51, 51, 51);">Setup takes less than two minutes. If you need any assistance, feel free to reach out directly.</p><p style="color: rgb(51, 51, 51);"><br>Best regards,</p><p style="color: rgb(51, 51, 51);"><span as="span" style="white-space: normal;"><span>{{profile.firstName}}</span></span> <span as="span" style="white-space: normal;"><span>{{profile.lastName}}</span></span> </p><p style="font-size: 14px; line-height: 1.6; margin: 0 0 10px 0; color: #333;"></p>\n  </div>\n  <!--[if mso]>\n  </td></tr></table>\n  <![endif]-->\n</body>\n</html>',
    },
  ];
};

// ─── Main Screen (thin wrapper) ──────────────────────────────────────────────
// This component ONLY manages the editing vs listing toggle.
// All Redux subscriptions / side-effects live inside the children so that
// re-renders from loanPipeline, cachedData, etc. can never reset activeTemplate.
const EmailTemplateManagerScreen = () => {
  const [activeTemplate, setActiveTemplate] = useState(null);

  const handleOpenEditor = useCallback((templateData) => {
    setActiveTemplate(templateData);
  }, []);

  const handleCloseEditor = useCallback(() => {
    setActiveTemplate(null);
  }, []);

  if (activeTemplate) {
    return (
      <TemplateEditorFullScreen
        key={activeTemplate?._id || "new"}
        template={activeTemplate}
        onClose={handleCloseEditor}
      />
    );
  }

  return <TemplateListScreen onOpenEditor={handleOpenEditor} />;
};

// ─── Template List Screen ────────────────────────────────────────────────────
// Separated so that all the Redux subscriptions, effects, and hooks that can
// trigger re-renders are isolated here and cannot touch `activeTemplate`.
const TemplateListScreen = ({ onOpenEditor }) => {
  const cachedData = useSelector(
    (state) => state?.cachedData?.[CACHED_DATA_KEY],
  );
  const loanPipeline = useSelector((state) => state?.loanPipeline);
  const [lastSynced, setLastSynced] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [quickFilter, setQuickFilter] = useState(null);

  const dispatch = useDispatch();
  const ref = useRef();

  const { getEmailTemplates, loading } = useNotificationFlowsHook();

  const filteredApps = useMemo(() => {
    return cachedData;
  }, [cachedData]);

  useEffect(() => {
    if (isArray(cachedData)) {
      return;
    }
    dispatch(cachedDataItemSet(CACHED_DATA_KEY, getDummyEmailTemplates({})));
    return;
    // dispatch(
    //   cachedDataItemSet(CACHED_DATA_KEY, DUMMY_BORROWER_PORTAL_USERS_ALL),
    // );
    // dispatch(cachedDataItemSet(CACHED_DATA_KEY, DUMMY_BORROWER_PORTAL_USERS));
    // return;
    if (isNil(cachedData)) {
      getEmailTemplates({});
    }
  }, [cachedData]);

  const onRowClicked = useCallback(
    (props) => {
      onOpenEditor(props.data);
    },
    [onOpenEditor],
  );

  const handleAddNew = useCallback(() => {
    onOpenEditor({
      name: "custom",
      templateTitle: null,
      description: null,
      subject: null,
      body: null,
    });
  }, [onOpenEditor]);

  return (
    <Screen sx={{ background: grey[50] }}>
      <TitledHeaderWithSearch
        title="Email Template Manager"
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
        endContent={
          <Button
            size="large"
            startIcon={<AddRounded />}
            onClick={handleAddNew}
          >
            Create New Template
          </Button>
        }
        titleEndContent={
          <Box sx={{ position: "relative" }}>
            <ChipItem value="Demo" />
            {/* <Flx
              ac
              gap={0.5}
              sx={{
                position: "absolute",
                width: "max-content",
                top: -14,
                left: 0,
              }}
            >
              <Tooltip title="Refresh Templates">
                <IconButton
                  size="small"
                  onClick={() =>
                    dispatch(cachedDataItemSet(CACHED_DATA_KEY, null))
                  }
                >
                  {loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <SyncOutlined className="thin" />
                  )}
                </IconButton>
              </Tooltip>
              {lastSynced && <Txt secondary>Last Synced: {lastSynced}</Txt>}
            </Flx> */}
          </Box>
        }
      />

      <Container maxWidth="xl" sx={{ py: 2 }}>
        <TemplatesTable
          showAll={showAll}
          loading={loading}
          ref={ref}
          rowData={filteredApps}
          onRowClicked={onRowClicked}
          quickFilter={quickFilter}
        />
      </Container>
      {/* <Container maxWidth="lg">
        <PrimaryContentCard
          cardSx={{ p: 0, mt: 2 }}
          // headerSx={{ p: 2, pb: 0 }}
          bodySx={{ p: 0 }}
        >
          <TemplatesTable
            showAll={showAll}
            loading={loading}
            ref={ref}
            rowData={filteredApps}
            onRowClicked={onRowClicked}
            quickFilter={quickFilter}
          />
        </PrimaryContentCard>
      </Container> */}
    </Screen>
  );
};

// ─── Full-Screen 2-Pane Editor ───────────────────────────────────────────────
// ─── Full-Screen 2-Pane Editor ───────────────────────────────────────────────
const TemplateEditorFullScreen = ({ template, onClose }) => {
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [subject, setSubject] = useState(null);
  const [body, setBody] = useState(null);
  const [emailCopied, setEmailCopied] = useState(false);
  const [previewMode, setPreviewMode] = useState("desktop"); // "desktop" | "mobile"

  const editorRef = useRef(null);
  const previewEditorRef = useRef(null);
  const initialBody = useMemo(() => template.body, [template.body]);
  const isNew = !template?._id;
  const handleBodyChange = useCallback((htmlString) => {
    setBody(htmlString);
  }, []);

  useEffect(() => {
    setSubject(template.subject);
    setTitle(template.templateTitle);
    setDescription(template.templateDescription);
    setBody(template.body);
  }, [template]);

  const onSubmit = useCallback(async () => {
    const emailHtml = editorRef.current
      ? await exportToEmailHtml(editorRef.current)
      : body;
    console.log("save", {
      templateTitle: title,
      templateDescription: description,
      subject,
      body: emailHtml,
    });
  }, [title, description, subject, body]);

  const handleCopyEmailHtml = useCallback(async () => {
    if (!editorRef.current) return;
    try {
      const emailHtml = await exportToEmailHtml(editorRef.current);
      await navigator.clipboard.writeText(emailHtml);
      setEmailCopied(true);
      setTimeout(() => setEmailCopied(false), 2000);
    } catch (err) {
      console.error("Failed to export email HTML", err);
    }
  }, []);

  return (
    <Screen sx={{ background: grey[100] }}>
      {/* ── Top toolbar ── */}
      <Flx
        ac
        sx={{
          height: 52,
          px: 2,
          borderBottom: `1px solid ${grey[300]}`,
          background: "#fff",
          justifyContent: "space-between",
          flexShrink: 0,
        }}
      >
        <Flx ac gap={1.5}>
          <Tooltip title="Back to templates">
            <IconButton size="small" onClick={onClose}>
              <ArrowBackRounded sx={{ fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
          <Flx ac g={1}>
            <Txt
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                color: grey[800],
              }}
            >
              Template Editor
            </Txt>
            <ChipItem value="Demo" />
          </Flx>
        </Flx>

        <Flx ac gap={1}>
          <Tooltip title={emailCopied ? "Copied!" : "Copy email HTML"}>
            <Button
              size="small"
              variant="outlined"
              startIcon={
                <ContentCopyRounded sx={{ fontSize: "16px !important" }} />
              }
              onClick={handleCopyEmailHtml}
              sx={{
                // textTransform: "none",
                // fontSize: "13px",
                borderColor: grey[300],
                color: grey[700],
                "&:hover": { borderColor: grey[400] },
              }}
            >
              {emailCopied ? "Copied!" : "Copy HTML"}
            </Button>
          </Tooltip>
          <Button
            size="small"
            variant="outlined"
            disableElevation
            startIcon={<SendOutlined sx={{ fontSize: "16px !important" }} />}
            onClick={onSubmit}
            // sx={{
            //   textTransform: "none",
            //   fontSize: "13px",
            // }}
          >
            Send Test Email
          </Button>
          <Button
            size="small"
            variant="contained"
            disableElevation
            startIcon={<SaveOutlined sx={{ fontSize: "16px !important" }} />}
            onClick={onSubmit}
            // sx={{
            //   textTransform: "none",
            //   fontSize: "13px",
            // }}
          >
            Save Template
          </Button>
          {/* <Tooltip title="Close">
            <IconButton size="small" onClick={onClose}>
              <CloseRounded sx={{ fontSize: 20, color: grey[500] }} />
            </IconButton>
          </Tooltip> */}
        </Flx>
      </Flx>
      {/* ── 2-pane layout ── */}
      <FlxGrid
        // gap={4}
        sx={{
          // p: 3,
          gridTemplateColumns: "680px 1fr",
          // gridTemplateColumns: "1.5fr 3fr",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* ── LEFT: Editor ── */}

        <PrimaryContentCard
          subTitle={description}
          title={title || "Untitled Template"}
          // title={isNew ? "Create New Template" : title || "Untitled Template"}
          // subTitle={
          //   isNew ? "Create New Template" : title || "Untitled Template"
          // }
          titleEndContent={
            !isNew ? (
              <ChipItem
                icon={<EditOutlined />}
                backgroundColor={yellow[100]}
                value={"Editing Template"}
              />
            ) : (
              <ChipItem
                backgroundColor={blue[50]}
                icon={<AddRounded />}
                value={"New"}
              />
            )
          }
          sx={{
            //
            width: "100%",
            // maxWidth: 880,
            // maxWidth: 720,
            mx: "auto",
            // overflowY: "auto",
            p: 3,

            pt: 3.5,
          }}
          // headerSx={{ p: 2, borderBottom: `3px solid ${grey[100]}`, mb: 0 }}
          // bodySx={{ p: 0, overflowY: "auto" }}
          // cardSx={{ p: 0, overflow: "hidden" }}
          cardSx={{
            overflowY: "auto",
            mb: 0,
            borderTopLeftRadius: "0px",
            // borderTopRightRadius: '0px',
            borderBottomLeftRadius: "0px",
          }}
        >
          {/* ─ Meta fields: Title + Description ─ */}
          <Flx
            column
            sx={
              {
                // p: 3,
                //
              }
            }
          >
            <Flx
              column
              gap={1.5}
              sx={{
                mt: 1,
                pt: 4,
                //
                mb: 8,
                borderTop: `3px solid ${grey[100]}`,
              }}
            >
              <SectionTitle>Template Info (Internal Only)</SectionTitle>
              <Flx column gap={3}>
                <StackedField
                  label="Title"
                  value={title}
                  onChange={setTitle}
                  placeholder="Template name..."
                />
                <StackedField
                  label="Description"
                  value={description}
                  onChange={setDescription}
                  placeholder="What is this template for?"
                />
              </Flx>
            </Flx>

            {/* <Divider sx={{ my: 5 }} /> */}

            {/* ─ Email fields: Subject + Body ─ */}

            <Flx column gap={1.5}>
              <SectionTitle>Email Content</SectionTitle>
              <Flx column gap={3}>
                <StackedField
                  label="Subject"
                  value={subject}
                  onChange={setSubject}
                  placeholder="Email subject line..."
                />

                <Flx column g={0.5} sx={{ mb: 0.75 }}>
                  <Txt
                    sx={{
                      fontSize: "13px",
                      fontWeight: 600,
                      color: grey[900],
                    }}
                  >
                    Body
                  </Txt>
                  <Box
                    sx={{
                      border: `1px solid ${grey[200]}`,
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                    }}
                  >
                    <BlockNoteEditor
                      // value={initialBody}
                      value={body}
                      editorRef={editorRef}
                      suppressOuterBorder
                      borderRadius="0px"
                      maxHeight="unset"
                      enableTemplateVariables
                      minHeight={"400px"}
                      onChange={handleBodyChange}
                      placeholder="Edit template body..."
                    />
                  </Box>
                </Flx>
              </Flx>
            </Flx>
          </Flx>
        </PrimaryContentCard>

        {/* ── RIGHT: Live Email Preview ── */}
        <Box
          sx={{
            p: 2,
            px: 3,
            // p: 3,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            background: grey[100],
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Preview header with device toggle */}
          <Flx
            ac
            sx={{
              // px: 2.5,
              flexShrink: 0,
              justifyContent: "space-between",
            }}
          >
            <Flx ac gap={0.75}>
              <VisibilityOutlined sx={{ fontSize: 16, color: grey[500] }} />
              <Txt
                sx={{
                  fontSize: "12px",
                  fontWeight: 700,
                  color: grey[600],
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Email Preview
              </Txt>
            </Flx>

            {/* Desktop / Mobile toggle */}
            <Flx
              ac
              sx={{
                background: grey[200],
                borderRadius: "8px",
                p: "3px",
                border: `1px solid ${grey[300]}`,
                gap: "2px",
              }}
            >
              <DeviceToggleButton
                active={previewMode === "desktop"}
                icon={<DesktopMacOutlined sx={{ fontSize: "14px" }} />}
                onClick={() => setPreviewMode("desktop")}
                label="Desktop"
              />
              <DeviceToggleButton
                active={previewMode === "mobile"}
                icon={<PhoneIphone sx={{ fontSize: "14px" }} />}
                onClick={() => setPreviewMode("mobile")}
                label="Mobile"
              />
            </Flx>
          </Flx>

          {/* Preview body */}
          <Box
            sx={{
              p: 3,
              pt: 0.5,
              flexGrow: 1,
              overflowY: "auto",
              display: "flex",
              justifyContent: "center",
              // alignItems: previewMode === "mobile" ? "flex-start" : "stretch",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: previewMode === "mobile" ? "380px" : "720px",
                height: previewMode === "mobile" ? "620px" : "100%",
                // height: previewMode === "mobile" ? "720px" : "100%",
                // maxWidth: 880,
                transition: "230ms",
                mx: "auto",
                background: "#fff",
                borderRadius: "10px",
                border: `1px solid ${grey[300]}`,

                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              }}
            >
              {/* Mock window chrome */}
              <Box
                sx={{
                  px: 2,
                  py: 1.25,
                  background: grey[50],
                  borderBottom: `1px solid ${grey[200]}`,
                  display: "flex",
                  gap: 0.75,
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: grey[300],
                  }}
                />
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: grey[300],
                  }}
                />
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    background: grey[300],
                  }}
                />
              </Box>

              {/* Subject / meta */}
              <Box
                sx={{
                  p: 2,
                  borderBottom: `1px solid ${grey[100]}`,
                }}
              >
                <Flx wrap ac>
                  <Txt
                    sx={{
                      fontSize: "11px",
                      color: grey[500],
                      width: 47,
                      // textAlign: "right",
                    }}
                  >
                    Subject:
                  </Txt>
                  <Txt
                    sx={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: grey[800],
                      wordBreak: "break-word",
                    }}
                  >
                    {subject || "—"}
                  </Txt>
                </Flx>
              </Box>

              {/* Rendered email body */}
              <Box
                sx={{
                  overflowY: "auto",
                  flexGrow: 1,
                  ".bn-editor": { paddingInline: "16px" },
                }}
              >
                <BlockNoteEditor
                  value={body?.htmlString}
                  readOnly
                  editorRef={previewEditorRef}
                  suppressOuterBorder
                  borderRadius="0px"
                  maxHeight="unset"
                  minHeight="400px"
                  onChange={handleBodyChange}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </FlxGrid>
    </Screen>
  );
};

// ─── Stacked Field (label above input, like the reference image) ─────────────
const StackedField = ({ label, value, onChange, placeholder }) => {
  return (
    <Flx column g={0.5} sx={{ mb: 0.75 }}>
      <Txt
        sx={{
          fontSize: "13px",
          fontWeight: 600,
          color: grey[900],
        }}
      >
        {label}
      </Txt>
      <Box
        sx={{
          border: `1px solid ${grey[200]}`,
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          "input, .MuiChip-label": { fontSize: "13px" },
        }}
      >
        <TextInput
          value={value}
          onChange={(val) => onChange(val)}
          placeholder={placeholder || `Enter ${label?.toLowerCase()}...`}
          sx={{ "& fieldset": { border: "none" } }}
        />
      </Box>
    </Flx>
  );
};

const SectionTitle = ({ children }) => {
  return (
    <Txt
      sx={{
        // fontSize: "11px",
        fontSize: "13px",
        // fontSize: "15px",
        fontWeight: 400,
        color: grey[500],
        textTransform: "uppercase",
        // fontStyle: "italic",
        mb: 0.5,
        // letterSpacing: "0.05em",
        // letterSpacing: "0.05em",
      }}
    >
      {children}
    </Txt>
  );
};

// ─── Device Toggle Button ────────────────────────────────────────────────────
const DeviceToggleButton = ({ active, onClick, label, icon }) => (
  <Button
    startIcon={icon}
    variant={active ? "contained" : "text"}
    onClick={onClick}
    sx={{
      px: 1.5,
      py: 0.5,
      borderRadius: "6px",
      fontSize: "11px",
      fontWeight: 600,
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.15s ease",
      background: active ? "#fff" : "transparent",
      color: active ? grey[800] : grey[500],
      boxShadow: active ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
      "&:hover": {
        color: active ? grey[800] : grey[700],
      },
    }}
  >
    {label}
  </Button>
);

// ─── Templates AG Grid Table ─────────────────────────────────────────────────
const TemplatesTable = forwardRef(
  ({ quickFilter, rowData, showAll = false, onRowClicked, loading }, ref) => {
    const { id } = useParams();
    const columnTypes = useColumnTypes();

    const sideBar = useMemo(() => {
      if (showAll) return sideBarColumnsFilters();
      return null;
    }, [showAll]);

    const columnDefs = useMemo(
      () => [
        {
          headerName: "Title",
          field: "templateTitle",
          minWidth: 220,
        },
        {
          headerName: "Description",
          field: "templateDescription",
        },
        {
          headerName: "Subject",
          field: "subject",
        },
        {
          headerName: "Is Shared",
          field: "isSharedTemplate",
        },
        {
          headerName: "Name",
          field: "name",
          width: 140,
          minWidth: 120,
          flex: 0,
        },
      ],
      [],
    );

    const handleOnRowClicked = useCallback(
      (props) => {
        onRowClicked(props);
      },
      [onRowClicked],
    );

    const defaultColDef = useMemo(() => {
      return {
        enableRowGroup: true,
        floatingFilter: false,
        filter: colDefFilterMultiSelect,
        showRowGroup: false,
        suppressHeaderFilterButton: true,
        suppressMenu: true,
        flex: 1,
        minWidth: 200,
        cellClass: "ag-cell-vertical-center",
      };
    }, []);

    const getRowStyle = useCallback(
      (props) => {
        if (id === props.data?._id) {
          return { backgroundColor: blue[50] };
        }
      },
      [id],
    );

    return (
      <AgGridTableWrapper
        // noBorder
        compactTable
        sx={{ flexGrow: 1, width: "100%" }}
      >
        <AgGridReact
          rowData={rowData}
          ref={ref}
          columnDefs={columnDefs}
          getRowStyle={getRowStyle}
          quickFilterText={quickFilter}
          domLayout="autoHeight"
          defaultColDef={defaultColDef}
          onRowClicked={handleOnRowClicked}
          getRowId={(params) => params.data?._id}
          groupDisplayType="groupRows"
          columnTypes={columnTypes}
          loading={loading}
          sideBar={sideBar}
        />
      </AgGridTableWrapper>
    );
  },
);

export default EmailTemplateManagerScreen;
